import React from 'react'
import { Box, Chip, Paper, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { usePage } from '@inertiajs/react'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'
import FormattedCurrency from '../../../../components/ui/FormattedCurrency'

Show.layout = (page) => <AppShell>{page}</AppShell>

export default function Show({ property, generator, payables = [] }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}`

  return (
    <Box>
      <PageHeader
        title={`Verbindlichkeit: ${generator.contact_name || ''}`}
        breadcrumbs={[
          { label: property.name, href: basePath },
          { label: 'Verbindlichkeiten', href: `${basePath}/payables` },
          { label: generator.contact_name || `#${generator.id}` },
        ]}
      />

      <Paper elevation={0} sx={{ p: 2, mb: 2, border: '1px solid', borderColor: 'divider' }}>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
          <Typography variant="body2" color="text.secondary">Kreditor: {generator.contact_name}</Typography>
          <Typography variant="body2" color="text.secondary">Kostenart: {generator.cost_category_name}</Typography>
          <Typography variant="body2" color="text.secondary">
            Netto: <FormattedCurrency value={generator.amount} align="left" />
          </Typography>
          <Typography variant="body2" color="text.secondary">
            USt: <FormattedCurrency value={generator.vat_amount} align="left" />
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Brutto: <FormattedCurrency value={generator.gross_amount} align="left" />
          </Typography>
          {generator.frequency && (
            <Typography variant="body2" color="text.secondary">
              Frequenz: {generator.frequency}
            </Typography>
          )}
          {generator.payment_method && (
            <Typography variant="body2" color="text.secondary">
              Zahlweise: {generator.payment_method}
            </Typography>
          )}
          <Typography variant="body2" color="text.secondary">
            Gültig ab: {generator.valid_from}
          </Typography>
          {generator.valid_until && (
            <Typography variant="body2" color="text.secondary">
              Gültig bis: {generator.valid_until}
            </Typography>
          )}
          {generator.reference && (
            <Typography variant="body2" color="text.secondary">
              Referenz: {generator.reference}
            </Typography>
          )}
          <Chip label={generator.recurring ? 'Wiederkehrend' : 'Einmalig'} size="small"
            color={generator.recurring ? 'primary' : 'default'} variant="outlined" />
        </Box>
      </Paper>

      <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
        Verbindlichkeiten ({payables.length})
      </Typography>

      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell sx={{ fontWeight: 600 }}>Periode</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Fällig</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Betrag</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Zugeordnet</TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="right">Offen</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {payables.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                  <Typography color="text.secondary">Keine Verbindlichkeiten vorhanden.</Typography>
                </TableCell>
              </TableRow>
            )}
            {payables.map((p) => (
              <TableRow key={p.id} data-testid={`payable-row-${p.id}`}>
                <TableCell>{String(p.period_month).padStart(2, '0')}/{p.period_year}</TableCell>
                <TableCell>{p.due_date}</TableCell>
                <TableCell align="right"><FormattedCurrency value={p.gross_amount} /></TableCell>
                <TableCell align="right"><FormattedCurrency value={p.allocated_amount} /></TableCell>
                <TableCell align="right"><FormattedCurrency value={p.open_amount} /></TableCell>
                <TableCell>
                  <Chip
                    label={p.paid ? 'Bezahlt' : 'Offen'}
                    size="small"
                    color={p.paid ? 'success' : 'warning'}
                    variant="outlined"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
